import { BaseEntity } from "@astrocentro-webapp/ui/modules/commons/entities/BaseEntity";
import { SellerServicesEntity } from "@astrocentro-webapp/ui/modules/sellers/entities/SellerServicesEntity";
import { camelizeKeys } from "humps";

export class SellerEntity extends BaseEntity {
  services;

  constructor(props) {
    super(camelizeKeys(props));
    this.services = props.services?.length
      ? new SellerServicesEntity(props.services)
      : { services: [], cheapest: null };
  }

  get price() {
    if (!this.services.cheapest) return "";
    return this.services.cheapest.price.formatted;
  }
}
